import { create } from "zustand";
import type { RuntimeMode } from "../data/repository-factory";

const MODE_KEY = "salespilot-runtime-mode";

function readMode(): RuntimeMode | null {
  const stored = window.localStorage.getItem(MODE_KEY);
  return stored === "demo" || stored === "cloud" ? stored : null;
}

interface AppState {
  mode: RuntimeMode | null;
  setMode: (mode: RuntimeMode) => void;
  clearMode: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  mode: readMode(),
  setMode(mode) {
    window.localStorage.setItem(MODE_KEY, mode);
    set({ mode });
  },
  clearMode() {
    window.localStorage.removeItem(MODE_KEY);
    set({ mode: null });
  }
}));
